import { BreezeIntelligenceEnrichmentProvider } from '../BreezeIntelligenceEnrichmentProvider/BreezeIntelligenceEnrichmentProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function DataTestPanelProvider({
  children
}) {
  return /*#__PURE__*/_jsx(BreezeIntelligenceEnrichmentProvider, {
    children: children
  });
}